import { useEffect } from 'react';

const REACT_READY_EVENT = 'reactAppReady';

const useReactReady = () => {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent(REACT_READY_EVENT));
  }, []);
};

export { useReactReady };
